import {lazy} from "react";

const PublicLink = lazy(() => import("./PublicLink"));
const RemoteCapture = lazy(() => import("./RemoteCapture"));

const publicLinkRoutes = [
    {
        path: "/p/:linkName",
        element: <PublicLink/>,
    },
    {
        path: "/remote-capture",
        element: <RemoteCapture/>,
    }
];

export default publicLinkRoutes;